type GameEventLike = {
  tag_data?: { metadata?: unknown } | null;
  pitch_data?: unknown;
  hit_data?: unknown;
};

/**
 * Game state corrections are posted as tags with `metadata: null` and no
 * sensor data. Omnibus leaves them out of the game CSV
 * (`data_csv.is_tag_only_without_metadata`) but still returns them from
 * `/game/{id}/events`, so they must be hidden here for the two views to match.
 *
 * Only an explicit `null` counts: batting practice tags legitimately send
 * `metadata: {}`.
 */
export const isGameStateCorrectionTag = (event: GameEventLike): boolean =>
  !!event.tag_data &&
  event.tag_data.metadata === null &&
  event.pitch_data == null &&
  event.hit_data == null;
